import {
  string, object, number,
} from 'yup';
import {
  REG_EX, VALIDATION_PROPERTIES, isValidReductionPercentage,
} from '../../../common/validation-rules';

const generalInformationFormSchema = object().shape({
  firmName: string()
    .max(50, VALIDATION_PROPERTIES.maxAllow50characters)
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  typeOfOffice: number()
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  advisorOriginType: number()
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
});

const onBoardingInformationFormSchema = object().shape({
  firstContactPersonFirstName: string()
    .matches(REG_EX.restrictSpecialCharacter, VALIDATION_PROPERTIES.noSpecialCharactersAllowed)
    .max(50, VALIDATION_PROPERTIES.maxAllow50characters)
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  firstContactPersonLastName: string()
    .matches(REG_EX.restrictSpecialCharacter, VALIDATION_PROPERTIES.noSpecialCharactersAllowed)
    .max(50, VALIDATION_PROPERTIES.maxAllow50characters)
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  firstContactPersonMiddleName: string()
    .matches(REG_EX.restrictSpecialCharacter, VALIDATION_PROPERTIES.noSpecialCharactersAllowed)
    .max(50, VALIDATION_PROPERTIES.maxAllow50characters)
    .notRequired()
    .nullable(),
  gender: number()
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  firstContactPersonEmail: string(VALIDATION_PROPERTIES.invalid)
    .matches(REG_EX.email, VALIDATION_PROPERTIES.invalid)
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
});

const invoicingInformationFormSchema = object().shape({
  typeOfInvoice: number()
    .required(VALIDATION_PROPERTIES.required)
    .nullable(),
  reductionPercentage: number()
    .test('reductionPercentage', 'Maximaal 100', (val) => (isValidReductionPercentage(val))),
});

export {
  generalInformationFormSchema,
  onBoardingInformationFormSchema,
  invoicingInformationFormSchema,
};
